<template>
	<div class="owl-carousel">
		<div class="item" v-for="item in items">
			<div class="containerItem2">
				<div class="top">
					<a class="img" :href="item.href" :style='`background-image: url(${item.img})`'>
						<!-- <img :src="item.img" alt=""> -->
					</a>
				</div>
				<div class="text">
					<a :href="item.href">
						<b>{{item.text}}</b>
					</a>
				</div>
				<div class="bottom">
					<div class="time">
						<span>
							<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="16" height="17" viewBox="0 0 16 17"> <metadata><?xpacket begin="﻿" id="W5M0MpCehiHzreSzNTczkc9d"?> <x:xmpmeta xmlns:x="adobe:ns:meta/" x:xmptk="Adobe XMP Core 5.6-c142 79.160924, 2017/07/13-01:06:39 "> <rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"> <rdf:Description rdf:about=""/> </rdf:RDF> </x:xmpmeta> <?xpacket end="w"?></metadata> <image id="icons8-time" width="16" height="17" xlink:href="data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAARCAMAAADjcdz2AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAA/FBMVEVESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk4AAAAEhMBKAAAAUnRSTlMAIfb7/PdqiodoExV9sdDLrHgRueVmnp/RZcbMeqcg+GdXTIWII9Pd2O9EP1nNCT6UATzZe46vb1qjGeLkKh0MHw8Okzg6kc5Nw2QzxMUIYuZheZRjHgAAAAFiS0dEU3pnHQYAAAAJcEhZcwAACxIAAAsSAdLdfvwAAAAHdElNRQfhCxsRGh0vy9xNAAAAwklEQVQY002P11ICURBEG1gEhSXnIFFAJIjkoCRJuwTp//8YdxYo6IfpPj1Tt+oCIovVptgteNCTw/ksi5cLutyqx+vzBxAMuYTDpCcSjZHxBJMGp5g2L19VZrI5IM/C7aUi34xpLUEtX5vKO1DlB2qsN8yiyiY+2QK+2O5I1WIXPbus+uRAPOPDUJEwGk++xZUhsvyRNJ3KnDGOOSP3H0S5AJb8vfGKa7EN8xfesm56I8Gdpuvanofj9fT0R0Ohs+R/wXcaDJiUt84AAAAASUVORK5CYII="/> </svg>
						</span>
						<span>
							{{item.time}}
						</span>
					</div>
					<a :href="item.href" class="button waves-effect waves-light">
						{{item.button}}
					</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
module.exports = {

	props: ['items'],

	data () {
		return {}
	},

	updated() {
		this.$emit('updated', {
			owlSettings: {
				items: 1,
				loop: this.items.length > 3 ? true : false,
				nav: true,
				dots: true,
				margin: 28,
				responsive: {
					0: {
						items: 1,
					},
					1024: {
						items: 2,
					},
					1180: {
						items: 4,
					}
				}
			}
		});
	}
}
</script>

<style lang="scss" scope=".slider-lowCost">
@import "scss/wanted";

.slider-stock2 {
	margin-bottom: 85px;
		b{
			font-weight: 900;
		}
		.owl-carousel {
			position: relative;
			padding: 0 2px 70px 2px;
			.owl-stage-outer{
				// padding: 0 1px;
			}
			.item {
				.containerItem2{
					border: 1px solid #e2edf3;
					box-shadow: 0px 0px 2px #e2edf3;
					border-radius: 6px;
					margin: 1px;
					.img{
						width: 100%;
						height: 134px;
						border-radius: 5px 5px 0px 0px;
            background-position: center;
            background-size: cover;
						background-size: contain;
						background-position: center;
						background-repeat: no-repeat;
						border-bottom: 1px solid #e2edf3;
            // background-image: darkgrey;
					}
					.top{
						display: flex;
						justify-conent: center;
						align-items: center;
						overflow: hidden;
					}
					.text{
						padding-top: 26px;
						padding-left: 30px;
						padding-right: 30px;
						a{
							text-decoration: none;
							height: rem(42);
							overflow: hidden;
							display: block;
							&:hover{
								text-decoration: underline;
							}
						}
						b{
							color: black;
						}
					}
					.bottom{
						padding-bottom: 30px;
						display: flex;
						justify-content: space-between;
						&:after{
							content: "";
							width: 98%;
							position: absolute;
							top: -2px;
							left: 3px;
							right: 0;
							height: 2px;
							background: #fff;
						}
					}
					.time{
						margin-top: 23px;
						display: flex;
						align-items: center;
						margin-left: 30px;
						position: relative;
						font-size: rem(12);
						color: #444a4e;
						justify-content: space-between;
						span{
							&:nth-child(1){
								position: relative;
								top: 2px;
								bottom: 0;
							}
							&:nth-child(2){
								white-space: nowrap;
								margin-left: 10px;

							}
						}
					}
					.button{
						margin-top: 23px;
						margin-right: 30px;
						@include l_only {
							padding: 0 20px;
							min-height: 35px;
							font-size: rem(13);
						}
					}
				}
			}
			.owl-dots{
				position: absolute;
				display: flex;
				align-items: center;
				height: 30px;
				width: 100%;
				bottom: 0;
			}
			.owl-dots{
				justify-content: flex-strat;
				padding-bottom: 3px;
				.owl-dot{
					display: flex;
					width: 12px;
					height: 12px;
					margin-right: 10px;
					justify-content: center;
					align-items: center;
					border-radius: 50%;
					transition: 0.4s ease-in-out;
					border: 1px solid black;
					position: relative;
					span{
						transition: 0.4s ease-in-out;
						width: 6px;
						border-radius: 50%;
						height: 6px;
						background-color: transparent;
						display: inline-block;
						position: absolute;
						margin: 0 auto;
						top: calc(50% - 3px);
						left: calc(50% - 3px);
					}
					&.active{
						border-width: 1px;
						border-style: solid;
					}
				}
			}
			.owl-nav{
				font-size: 0;
				display: flex;
				justify-content:space-between;
				width: 100px;
				position: absolute;
				right: 0;
				bottom: -34px;
				z-index: 11;
				div{
					width: 42px;
					height: 42px;
					border-radius: 100%;
					@include single-transition();
					background-size: 25px;
					background-position: center;
					background-repeat: no-repeat;
					background-image: url('../img/arr.svg');
					border: 1px solid black;
					background-color: #fff;
					&:hover{
						background-image: url('../img/arr2.svg');
					}
				}
				.owl-prev{
					bottom: 30px;
					transform: rotate(90deg);
					position: relative;
					left: 0;
				}
				.owl-next{
					bottom: 30px;
					transform: rotate(-90deg);
					position: relative;
					right: 0;
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// lowCost2.vue?75388b43